import React from 'react'
import { Result } from '../../helper/models/getProducts'
import { ImageProcess } from '../../helper/services/imageProcess'

const imageProcess = new ImageProcess()
const Category = ({ result }: { result: Result }) => {
  return (
    <div className="text-white">
      {result?.data.map((e) => (
        <div
          className="justify-around p-2 m-3 space-x-1 overflow-hidden rounded-lg min-w-fit bg-cyan-600"
          key={e.category_id}
        >
          <img
            src={imageProcess.process(e.category_image)}
            alt={e.category}
            key={e.category_image}
            className="inline-block w-10 h-10 rounded-lg"
          />
          <p className="inline-block">{e.category}</p>
        </div>
      ))}
    </div>
  )
}

export default Category
